<template>
    <div class="wrap">
        <div class="containter">
            <type-menu ref="typeMenu" no-edit :menu="tabs" :type-id="typeId" :sub-type-id="subTypeId"
                @getList="getList"></type-menu>
            <div class="content">
                <div class="c-header">
                    <div class="header-group-left">
                    </div>
                    <div class="header-group-right">
                        <div>
                            <el-input placeholder="请输入内容" v-model="query.keyword" class="input-with-select" size="mini">
                                <el-button slot="append" icon="el-icon-search" @click="getList()"></el-button>
                            </el-input>
                        </div>
                    </div>
                </div>


                <div class="c-main">
                    <div class="overflow-container">
                        <el-table :data="list" style="width: 100%" @selection-change="handleSelectionChange">
                            <el-table-column type="selection" width="55">
                            </el-table-column>
                            <el-table-column prop="title" label="标题" width="200" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column label="封面" width="">
                                <template slot-scope="scope">
                                    <el-image class="img-cover" :src="scope.row.cover"> </el-image>
                                </template>
                            </el-table-column>
                            <el-table-column prop="updatedAt" label="更新时间" width="">
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="page">
                        <el-pagination class="" @current-change="handleCurrentChange" :current-page="query.page"
                            :page-sizes="[10, 20, 50, 100]" :page-size="query.pageSize"
                            layout="total, prev, pager, next, jumper" :total="query.total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getSubCategories } from "@/api/material";

import TypeMenu from "@/pages/mall/components/TypeMenu.vue";


export default {
    components: {
        TypeMenu,
    },
    data() {
        return {
            tabs: [],
            list: [],
            typeId: "670e74efaf089a40acf16add", // 新闻id
            subTypeId: "",
            once: false,
            keyword: "",
            categoryId: "",
            query: {
                page: 1,
                total: 0,
                pageSize: 10,
                keyword: ''
            },
        };
    },
    watch: {
        list: {
            handler(val) {
                if (val.length === 0) {
                    this.checked = false;
                    return
                }
                const tag = val.every((item) => item.checked === true);

            },
            deep: true,
        },
    },
    created() {
        this.initList();
    },
    methods: {
        async initList() {
            this.query = {
                page: 1,
                total: 0,
                pageSize: 10,
                keyword: '',
            }
            await this.getList();
        },

        async getList(id) {
            if (id) {
                this.subTypeId = id;
                this.query = {
                    page: 1,
                    total: 0,
                    pageSize: 10,
                    keyword: '',
                }
            }
            const { status, data, message } = await getSubCategories({
                categoryId: this.typeId,
                page: this.query.page,
                pageSize: this.query.pageSize,
                filter: this.query.keyword,
            });
            if (status == 10000) {
                this.tabs = data;
                if (!this.once) {
                    this.subTypeId = this.tabs[0]?._id;
                    this.once = true;
                }
                const subList = data.filter((item) => item._id === this.subTypeId)[0];
                this.query.total = subList.totalPages;
                this.list = subList.materials.map((item) => {
                    return {
                        checked: false,
                        ...item,
                    };
                });
            } else {
                this.$message.error(message);
            }
        },

        handleCurrentChange(page) {
            this.query.page = page;
            this.getList();
        },

        handleSelectionChange(val) {
            const articleData = val.map((item) => {
                return {
                    id: item._id,
                    title: item.title,
                    cover: item.cover,
                    content: item.content,
                }
            })
            this.$emit('onChangeSelection', articleData);
        },
    },
};
</script>
<style lang="scss" scoped>
.wrap {
    width: 100%;
    height: 100%;

    .containter {
        width: 100%;
        height: 100%;
        display: flex;
        padding: 8px;

        .content {
            flex: 1 1 auto;
            min-width: 0;
            height: 100%;
            display: flex;
            flex-direction: column;
            padding: 0 0 0px 16px;
        }

        .c-header {
            display: flex;
            height: 32px;
            justify-content: space-between;
            align-items: center;

            &:nth-of-type(2n) {
                margin-top: 8px;
            }
        }

        .header-group-left {
            .el-button {
                min-width: 80px;

                &:first-child {
                    margin-right: 8px;
                }
            }
        }

        .c-main {
            position: relative;
            padding: 6px 0 42px;
            height: 100%;
            flex: 1 1 auto;
            min-height: auto;

            .overflow-container {
                height: 100%;
                overflow-y: auto;
           
                // 滚动条整体样式
                &::-webkit-scrollbar {
                    display: block;
                    width: 6px;
                    height: 6px;
                }

                // 滚动条轨道
                &::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 3px;
                }

                // 滚动条滑块
                &::-webkit-scrollbar-thumb {
                    background: #c1c1c1;
                    border-radius: 3px;

                    &:hover {
                        background: #a8a8a8;
                    }
                }
            }

            .page {
                display: flex;
                justify-content: flex-end;
                position: absolute;
                bottom: 0px;
                width: 100%;
            }
        }
    }
}
.img-cover{
    max-height: 100px;
}
</style>
<style>
.filepond--root :not(text) {
    font-size: 16px;
}
</style>